import { authApi } from '../../utils/api';

export const adminIptallerPage = () => {
    const user = authApi.getCurrentUser();

    if (!user || user.rol !== 'admin') {
        return `
            <section class="page-content">
                <div class="container">
                    <div class="alert alert-danger">
                        <p>Bu sayfaya erişim yetkiniz yok.</p>
                        <a href="/" class="btn-primary">Ana Sayfaya Dön</a>
                    </div>
                </div>
            </section>
        `;
    }

    return `
        <section class="page-content admin-page">
            <div class="container">
                <div class="page-header">
                    <h1 class="page-title">İptal İşlemleri</h1>
                    <div class="header-actions">
                        <a href="/admin" class="btn-outline">← Admin Paneli</a>
                        <button class="btn-primary" id="addIptalBtn">+ Yeni İptal</button>
                    </div>
                </div>

                <div id="iptalModal" class="modal" style="display: none;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2 id="iptalModalTitle">Yeni İptal Kaydı</h2>
                            <button class="modal-close" id="closeIptalModal">&times;</button>
                        </div>
                        <form id="iptalForm" class="modal-form">
                            <input type="hidden" id="iptalId">
                            <div class="form-group">
                                <label for="iptalPoliceId">Poliçe *</label>
                                <select id="iptalPoliceId" class="form-control" required>
                                    <option value="">Poliçe Seçin</option>
                                </select>
                            </div>
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="iptalTarihi">İptal Tarihi *</label>
                                    <input type="date" id="iptalTarihi" class="form-control" required>
                                </div>
                                <div class="form-group">
                                    <label for="iadeTutari">İade Tutarı (TL)</label>
                                    <input type="number" id="iadeTutari" class="form-control" step="0.01" min="0">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="iptalDurum">Durum</label>
                                <select id="iptalDurum" class="form-control">
                                    <option value="basvuruldu">Başvuruldu</option>
                                    <option value="onaylandi">Onaylandı</option>
                                    <option value="reddedildi">Reddedildi</option>
                                    <option value="tamamlandi">Tamamlandı</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="iptalNedeni">İptal Nedeni</label>
                                <textarea id="iptalNedeni" class="form-control" rows="2"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="iptalNotlar">Notlar</label>
                                <textarea id="iptalNotlar" class="form-control" rows="2"></textarea>
                            </div>
                            <div id="iptalFormError" class="error-message" style="display: none;"></div>
                            <div class="modal-actions">
                                <button type="button" class="btn-outline" id="cancelIptalBtn">İptal</button>
                                <button type="submit" class="btn-primary">Kaydet</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div id="iptallerList" class="data-table-container">
                    <div class="loading">Yükleniyor...</div>
                </div>
            </div>
        </section>
    `;
};
